<script lang="ts">
  // noaccess: static page to which users are redirected if SSO is successful but they were not added to the app by
  // application admin
  import { itdevcontact } from '$lib/constants';
</script>

<main class="container py-3" id="main-container">
  <div class="py-5">
    <div class="row">
      <div class="col col-md-8 col-lg-6 mx-auto">
        <div class="card">
          <div class="card-header"><h2 class="mb-0">No Access</h2></div>
          <div class="card-body">
            <p>
              SSO was successful but you do not have access to this application. Please contact
              <a href={itdevcontact}>UAMS IT Development</a> for support.
            </p>
            <div class="d-grid">
              <a href="/" class="btn btn-primary">Home</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
